// extracted by mini-css-extract-plugin
export default {"Img":"img_Img__C6P1n","img":"img_img__KGSJY","img_anime":"img_img_anime__0rqEs"};